import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { IcArrowLeft } from '@/assets/images';
import { JmsManagementRoutes } from '@/pages/JMS/Managament/utils/utils';
import { useBookingStore } from '@/pages/JMS/store/BookingStore';
import { MainRoutes } from '@/routes/RoutePaths';
import { formatPersonName } from '@/utils';

interface HeaderProps {
  title?: string;
}

export const Header = ({ title }: HeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const previousRouteRef = useRef<string | null>(null);

  const { booking } = useBookingStore();

  const ROUTES = {
    INMATES: JmsManagementRoutes.Inmates,
    BOOKINGS: JmsManagementRoutes.Bookings,
    SEARCH_PERSON: JmsManagementRoutes.SearchPerson,
  };

  const WIZARD_ROUTES = {
    CREATE_IDENTITY: JmsManagementRoutes.CreateIdentity,
    BOOKING: JmsManagementRoutes.CreateBooking,
    SEARCH: ROUTES.SEARCH_PERSON,
  };

  const WIZARD_ROUTES_MAP: Record<string, string> = {
    [WIZARD_ROUTES.BOOKING]: JmsManagementRoutes.CreateIdentity,
    [WIZARD_ROUTES.CREATE_IDENTITY]: ROUTES.SEARCH_PERSON,
    [WIZARD_ROUTES.SEARCH]:
      previousRouteRef.current === ROUTES.INMATES
        ? ROUTES.INMATES
        : ROUTES.BOOKINGS,
  };

  const IMPORTANT_ROUTES = new Set(Object.values(ROUTES));

  const onBack = () => {
    const currentPath = location.pathname;
    if (!booking?._id) {
      navigate(WIZARD_ROUTES_MAP[currentPath]);
      return;
    }

    const navigationMap: Record<string, string> = {
      [ROUTES.SEARCH_PERSON]: ROUTES.INMATES,
      [ROUTES.BOOKINGS]: ROUTES.INMATES,
    };
    const targetPath =
      navigationMap[currentPath] ||
      (IMPORTANT_ROUTES.has(previousRouteRef.current || '')
        ? previousRouteRef.current
        : ROUTES.INMATES);
    navigate(targetPath || ROUTES.INMATES);
  };

  const isJmsManagementRoute =
    location.pathname === MainRoutes.JmsManagement ||
    location.pathname === ROUTES.BOOKINGS;

  useEffect(() => {
    if (IMPORTANT_ROUTES.has(location.pathname)) {
      previousRouteRef.current = location.pathname;
    }
  }, [location.pathname]);

  return (
    <header className="top-0 z-10 w-full h-20 flex justify-between text-xl border-b-[1px] border-b-gray-300 font-medium p-4 bg-white">
      <div className="flex items-center gap-4">
        {!isJmsManagementRoute && (
          <div className="cursor-pointer" onClick={onBack} aria-label="Go back">
            <IcArrowLeft />
          </div>
        )}
        {(booking?._id || booking?.inmate?._id) && !isJmsManagementRoute ? (
          <h2>
            {title} &nbsp; <span className="text-red-500">&#183;</span> &nbsp;
            {formatPersonName(booking?.identity)}
          </h2>
        ) : (
          <h2>{title}</h2>
        )}
      </div>
    </header>
  );
};
